// dashbaord
import Default from "../Components/Dashboard/Default";
//User
import User from "../Components/User/User";
import AdminUser from "../Components/User/AdminUser";
//Details Info
import Tags from "../Components/DatailsInfo/Tag/Tags";
import Tagsdetails from "../Components/DatailsInfo/Tagsdetails/Tagsdetails";
import JourneyLocations from "../Components/DatailsInfo/Journeylocation/JourneyLocations";
import DocumentList from "../Components/DatailsInfo/Documentlist/DocumentList";

// Trip
import Trip from "../Components/Trip/Trip";

// Experience
import Experience from "../Components/Experience/Experience";

// Community
import Community from "../Components/Community/Community";

// Blog
import Blogs from "../Components/Blog/Blogs";

// Gallery
import Gallery from "../Components/Gallery/Gallery";

// Donation
// import Donation from "../Components/Donation/Donations";
import DonationTable from "../Components/Donation/DonationTable";

//Sos
import SosTable from "../Components/sos/SosTable";

//Notification
import Notification from "../Layout/Header/RightHeader/Notification";

import Ecommerce from "../Components/Dashboard/Ecommerce/Ecommerce";
import General from "../Components/Widgeta/General";
import Chart from "../Components/Widgeta/Chart";
import Project from "../Components/Project";
import CreateListContain from "../Components/Project/Create List";
import KanbanBoard from "../Components/KanbanBoard";
import Product from "../Components/Eccommerce/Products";
import ProductList from "../Components/Eccommerce/ProductList";
import PaymentDetails from "../Components/Eccommerce/PaymentDetails";
import OrderHistory from "../Components/Eccommerce/OrderHistory";
import Invoice from "../Components/Eccommerce/Invoice";
import WhishList from "../Components/Eccommerce/Wishlist";
import MailInbox from "../Components/Email/Mail Inbox";
import ReadMail from "../Components/Email/Read Mail";
import Compose from "../Components/Email/Compose";
import UsersProfileContain from "../Components/User/UsersProfile";
import UsersCardssContain from "../Components/User/UsersCards";
import UsersEditContain from "../Components/User/UsersEdit";
import BookmarksContain from "../Components/BookMarks";
import ContactApp from "../Components/Contact/ContactApp";
import Task from "../Components/Task";
import SocialApp from "../Components/SocialApp";
import TodoContain from "../Components/Todo/index";
import SearchResult from "../Components/Search Result";
import MegaOptionsContain from "../Components/Forms/Form Control/Mega Option";
import SupportTickit from "../Components/Support Tickit";
import RadioCheckbox from "../Components/Forms/Form Control/Radio Checkbox";
import InputGroup from "../Components/Forms/Form Control/Input Group";
import BaseInput from "../Components/Forms/Form Control/BaseInput";
import FormDefault from "../Components/Forms/Form Layout/Form Default";
import FormWizard from "../Components/Forms/Form Layout/Form Wizard";
import BasicTable from "../Components/Tables/Reactstrap/BasicTable";
import Typography from "../Components/UiKits/Typography";
import Avtars from "../Components/UiKits/Avtars";
import HelperClasses from "../Components/UiKits/HelperClass";
import Grid from "../Components/UiKits/Grid";
import TagAndPills from "../Components/UiKits/TagAndPills";
import Progressbars from "../Components/UiKits/Progress";
import Modals from "../Components/UiKits/Modals";
import Alert from "../Components/UiKits/Alert";
import PopOvers from "../Components/UiKits/Popover";
import Toollip from "../Components/UiKits/Tooltip";
import Spinners from "../Components/UiKits/Spinners";
import Dropdowns from "../Components/UiKits/Dropdown";
import Accordian from "../Components/UiKits/Accordian";
import TabBootstrap from "../Components/UiKits/Tabs/BootstrapTab";
import TabLine from "../Components/UiKits/Tabs/LineTab";
import Shadow from "../Components/UiKits/Shadows";
import Lists from "../Components/UiKits/Lists";
import FeatherIcon from "../Components/Icons/FeatherIcon";
import FlagIcon from "../Components/Icons/FlagIcon";
import Fontawesome from "../Components/Icons/FontawesomeIcon";
import IcoIcons from "../Components/Icons/IcoIcon";
import ThemifyIcons from "../Components/Icons/ThemifyIcon";
import WeatherIcons from "../Components/Icons/WeatherIcon";
import DefaultButton from "../Components/Buttons/Default";
import GroupButton from "../Components/Buttons/GroupBtn";
import LearningList from "../Components/Learning/LearningList";
import FAQContent from "../Components/FAQ";
import BlogDetail from "../Components/Blog/BlogDetail";
import BlogSingle from "../Components/Blog/BlogSingle";
import BlogPost from "../Components/Blog/BlogPost";
import ApplyContain from "../Components/JobSearch/Apply/index";
import JobDetails from "../Components/JobSearch/JobDetail";
import ListView from "../Components/JobSearch/ListView";
import JobCardsContain from "../Components/JobSearch/JobCardView";
import KnowledgeCategoryContain from "../Components/Knowledgebase/Knowledge Category";
import KnowledgeBaseContain from "../Components/Knowledgebase/Knowledgebase";
import KnowledgeDetailContain from "../Components/Knowledgebase/Knowledge Details";
import CkEditorContain from "../Components/Editor/CkEditor";
import ACEEditorContain from "../Components/Editor/Ace code editor/ACECodeEditor";
import MdeEDitorContain from "../Components/Editor/MDE Editor/MDEEditor";
import MesonryGalleryContain from "../Components/Gallery/MesonryGallery";
import MesonryDescContain from "../Components/Gallery/MesonryDesc";
import ImageHoverContain from "../Components/Gallery/ImageHover";
import ImageWithDescContain from "../Components/Gallery/ImageWithDesc";
import ImageGalleryContain from "../Components/Gallery/ImageGallery";
import SampleCard from "../Components/SampleCard";
import FormValidationContain from "../Components/Forms/Form Control/Form Validation";
import DetailCourseContain from "../Components/Learning/DetailCourse";
import ApexchartsContain from "../Components/Charts/apexCharts";
import GoogleChartsContain from "../Components/Charts/googleCharts";
import DraggableContain from "../Components/Calender/Draggable Calender/index";
import ChartistContain from "../Components/Charts/chartistCharts";
import ChartJsContain from "../Components/Charts/chartsjs";
import DataTablesContain from "../Components/Tables/DataTable";
import Scrollable from "../Components/BonusUi/Scrollable";
import TreeView from "../Components/BonusUi/TreeView";
import Rating from "../Components/BonusUi/Rating";
import Dropzone from "../Components/BonusUi/Dropzones";
import Tour from "../Components/BonusUi/Tour";
import SweetAlert from "../Components/BonusUi/SweetAlert";
import Ribbons from "../Components/BonusUi/Ribbons";
import Pagination from "../Components/BonusUi/Pagination";
import Breadcrumb from "../Components/BonusUi/Breadcrumb";
import RangeSlider from "../Components/BonusUi/RangeSlider";
import ImageCropper from "../Components/BonusUi/ImageCropper";
import StickyContain from "../Components/BonusUi/Sticky";
import DragAndDropContain from "../Components/BonusUi/DragAndDrop";
import UploadImageContain from "../Components/BonusUi/ImageUpload";
import BasicCardContain from "../Components/BonusUi/Cards/BasicCards";
import DragCards from "../Components/BonusUi/Cards/DragCards";
import TimeLineContain from "../Components/BonusUi/Timeline/timeline";
import PricingMembershipContain from "../Components/Eccommerce/PricingMemberShip";
import Cart from "../Components/Eccommerce/ProductCart";
import DateTimeContain from "../Components/Forms/Form Widgets/Date and Time";
import FormTypeaheadContain from "../Components/Forms/Form Widgets/Form Typeahead";
import FormTouchspinContain from "../Components/Forms/Form Widgets/Form Touchspin";
import Switch from "../Components/Forms/Form Widgets/Form Switch";
import Select from "../Components/Forms/Form Widgets/Form Select2";
import Clipboard from "../Components/Forms/Form Widgets/Form Clipboard";
import DatePicker from "../Components/Forms/Form Widgets/Form DataPicker";
import RangePicker from "../Components/Forms/Form Widgets/Form Date Rangepicker";
import CheckOutContain from "../Components/Eccommerce/CheckOut/index";
import AddProductName from "../Components/Eccommerce/AddProduct";
import FileManagerContain from "../Components/FileManager/index"
import MapJsContain from "../Components/Maps/pigeon-maps";
import GoolgeMapsContain from "../Components/Maps/GoogleMaps";
import EventsTable from "../Components/ArticleManagement/EventsTable";
import ExperienceTable from "../Components/ArticleManagement/ExperienceTable";
import QATable from "../Components/ArticleManagement/QATable";
import Listings from "../Components/Listing/Listings";
import TransactionTable from "../Components/Donation/TransactionTable";
import HistoryTabs from "../Components/Donation/HistoryTabs";
import Configurations from "../Components/Donation/Configurations";
import LearningTable from "../Components/LearningNew/LearningTable";
import PromotionsTable from "../Components/Promotions/PromotionsTable";
import HomeScreenConfigTable from "../Components/HomeScreenConfig/HomeScreenConfigTable";
import AdsTable from "../Components/Advertisement/AdsTable";
import CourseTable from "../Components/Courses/CourseTable";
import ChapterTable from "../Components/Chapters/ChapterTable";
import LessonTable from "../Components/Lessons/LessonTable";
import QuizManagementTable from "../Components/QuizManagement/QuizManagementTable";
import SosMaps from "../Components/sosMaps/index";
import FeedbackTable from "../Components/Feedback/FeedbackTable";
import ReportSafetyTable from "../Components/ReportSafety/ReportSafetyTable";
import LiveStreamManagement from "../Components/LiveDarshan/LiveStreamManagement";
import MultiyatraBeltTable from "../Components/KuberBelt/MultiyatraBeltTable";
import OnboardingVideosTable from '../Components/OnboardingVideos/OnboardingVideosTable';
import DeepLinkRedirectPage from "../Components/DeepLink/DeepLinkRedirectPage";
import ReferralAnalytics from "../Components/Referrals/ReferralAnalytics";
import NotificationTable from "../Components/Notifications/NotificationTable";
import DonationManagementTable from "../Components/Donation/DonationManagement/DonationManagementTable";
import StreamMonitor from "../Components/LiveDarshan/StreamMonitor";
import MultiViewManagement from "../Components/LiveDarshan/MultiViewManagement";

export const routes = [
  //dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Default /> },

  //User
  { path: `${process.env.PUBLIC_URL}/User`, Component: <User /> },

  //Admin User
  { path: `${process.env.PUBLIC_URL}/admin-user`, Component: <AdminUser /> },
  { path: `${process.env.PUBLIC_URL}/listing`, Component: <Listings /> },

  //Article Management
  { path: `${process.env.PUBLIC_URL}/events`, Component: <EventsTable /> },
  { path: `${process.env.PUBLIC_URL}/community-exp`, Component: <ExperienceTable/> },
  { path: `${process.env.PUBLIC_URL}/community-qa`, Component: <QATable/> },

  

  //Details Info
  { path: `${process.env.PUBLIC_URL}/DatailsInfo/tags`, Component: <Tags /> },
  { path: `${process.env.PUBLIC_URL}/DatailsInfo/Tagsdetails`, Component: <Tagsdetails /> },
  { path: `${process.env.PUBLIC_URL}/DatailsInfo/JourneyLocation`, Component: <JourneyLocations /> },
  { path: `${process.env.PUBLIC_URL}/DatailsInfo/Documentlist`, Component: <DocumentList /> },

  // Trip
  { path: `${process.env.PUBLIC_URL}/Trip`, Component: <Trip /> },

  // Experience
  { path: `${process.env.PUBLIC_URL}/Experience`, Component: <Experience /> },

  // Community
  { path: `${process.env.PUBLIC_URL}/Community`, Component: <Community /> },


  // Blog
  { path: `${process.env.PUBLIC_URL}/Blogs`, Component: <BlogDetail /> },

  // Gallery
  { path: `${process.env.PUBLIC_URL}/Gallery`, Component: <Gallery /> },

  // Donation
  // { path: `${process.env.PUBLIC_URL}/Donation`, Component: <DonationTable /> },
  // { path: `${process.env.PUBLIC_URL}donation-history`, Component: <DonationTable /> },
  // { path: `${process.env.PUBLIC_URL}transaction-history`, Component: <TransactionTable /> },
  { path: `${process.env.PUBLIC_URL}/donation-management`, Component: <DonationManagementTable /> },
  { path: `${process.env.PUBLIC_URL}/history`, Component: <HistoryTabs /> },
  { path: `${process.env.PUBLIC_URL}/configurations`, Component: <Configurations /> },

  // Learning
  { path: `${process.env.PUBLIC_URL}/artifacts`, Component: <LearningTable /> },

  // Promotions
  { path: `${process.env.PUBLIC_URL}/promotions`, Component: <PromotionsTable /> },

  // Home Screen Config
  { path: `${process.env.PUBLIC_URL}/home-screen-config`, Component: <HomeScreenConfigTable /> },

  //Advertisment
  { path: `${process.env.PUBLIC_URL}/advertisements`, Component: <AdsTable /> },

  //Profile
  { path: `${process.env.PUBLIC_URL}/reports`, Component: <ReportSafetyTable /> },
  { path: `${process.env.PUBLIC_URL}/feedback`, Component: <FeedbackTable /> },


  //Courses
  { path: `${process.env.PUBLIC_URL}/courses`, Component: <CourseTable /> },
  { path: `${process.env.PUBLIC_URL}/course/:courseId/chapters`, Component: <ChapterTable /> },
  { path: `${process.env.PUBLIC_URL}/chapter/:chapterId/lessons`, Component: <LessonTable /> },

  //Quiz Management
  { path: `${process.env.PUBLIC_URL}/quiz-management`, Component: <QuizManagementTable /> },


 
  { path: `${process.env.PUBLIC_URL}/live-streams`, Component: <LiveStreamManagement /> },
  { path: `${process.env.PUBLIC_URL}/multi-view`, Component: <MultiViewManagement /> },
  { path: `${process.env.PUBLIC_URL}/live-status`, Component: <StreamMonitor /> },
  { path: `${process.env.PUBLIC_URL}/multi-yatra-belt`, Component: <MultiyatraBeltTable /> },
  { path: `${process.env.PUBLIC_URL}/onboarding-videos`, Component: <OnboardingVideosTable /> },


  { path: `${process.env.PUBLIC_URL}/referrals`, Component: <ReferralAnalytics /> },



   // SOS
   { path: `${process.env.PUBLIC_URL}/sos`, Component: <SosTable /> },
   //Notifications
   { path: `${process.env.PUBLIC_URL}/sos/notifications/:userId`, Component: <Notification /> },

   //sos-maps
   { path: `${process.env.PUBLIC_URL}/maps/:latitude/:longitude`, Component: <SosMaps /> },

  { path: `${process.env.PUBLIC_URL}/forms/form-validation`, Component: <FormValidationContain /> },
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Default /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, Component: <Ecommerce /> },

  //widgets
  { path: `${process.env.PUBLIC_URL}/widgets/general`, Component: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart`, Component: <Chart /> },

  //Project
  { path: `${process.env.PUBLIC_URL}/project/project-list`, Component: <Project /> },
  { path: `${process.env.PUBLIC_URL}/project/new-project`, Component: <CreateListContain /> },
  { path: `${process.env.PUBLIC_URL}/kanban-board`, Component: <KanbanBoard /> },
  { path: `${process.env.PUBLIC_URL}/file-manager`, Component: <FileManagerContain /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/product`, Component: <Product /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/product-list`, Component: <ProductList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/payment-details`, Component: <PaymentDetails /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/orderhistory`, Component: <OrderHistory /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice`, Component: <Invoice /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/wishlist`, Component: <WhishList /> },
  { path: `${process.env.PUBLIC_URL}/email-app`, Component: <MailInbox /> },
  { path: `${process.env.PUBLIC_URL}/email/readmail`, Component: <ReadMail /> },
  { path: `${process.env.PUBLIC_URL}/email-app/compose`, Component: <Compose /> },

  { path: `${process.env.PUBLIC_URL}/users/userProfile`, Component: <UsersProfileContain /> },
  { path: `${process.env.PUBLIC_URL}/users/userEdit`, Component: <UsersEditContain /> },
  { path: `${process.env.PUBLIC_URL}/users/userCards`, Component: <UsersCardssContain /> },

  { path: `${process.env.PUBLIC_URL}/bookmark`, Component: <BookmarksContain /> },

  { path: `${process.env.PUBLIC_URL}/contact`, Component: <ContactApp /> },

  { path: `${process.env.PUBLIC_URL}/task`, Component: <Task /> },
  { path: `${process.env.PUBLIC_URL}/social-app`, Component: <SocialApp /> },
  { path: `${process.env.PUBLIC_URL}/todo-app/todo`, Component: <TodoContain /> },

  { path: `${process.env.PUBLIC_URL}/searchresult`, Component: <SearchResult /> },

  { path: `${process.env.PUBLIC_URL}/support-ticket`, Component: <SupportTickit /> },

  { path: `${process.env.PUBLIC_URL}/forms/radio-checkbox`, Component: <RadioCheckbox /> },
  { path: `${process.env.PUBLIC_URL}/forms/inputGroup`, Component: <InputGroup /> },
  { path: `${process.env.PUBLIC_URL}/forms/megaOptions`, Component: <MegaOptionsContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/baseInput`, Component: <BaseInput /> },

  { path: `${process.env.PUBLIC_URL}/form-layout/formDefault`, Component: <FormDefault /> },
  { path: `${process.env.PUBLIC_URL}/form-layout/formWizard`, Component: <FormWizard /> },

  { path: `${process.env.PUBLIC_URL}/table/reactstraptable`, Component: <BasicTable /> },

  { path: `${process.env.PUBLIC_URL}/ui-kits/typography`, Component: <Typography /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/avatar`, Component: <Avtars /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/helperclass`, Component: <HelperClasses /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/grid`, Component: <Grid /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tagsandpills`, Component: <TagAndPills /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/progress-bar`, Component: <Progressbars /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/modal`, Component: <Modals /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/alert`, Component: <Alert /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/popover`, Component: <PopOvers /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tooltips`, Component: <Toollip /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/spinner`, Component: <Spinners /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/dropdown`, Component: <Dropdowns /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/accordion`, Component: <Accordian /> },

  { path: `${process.env.PUBLIC_URL}/ui-kits/tab-bootstrap`, Component: <TabBootstrap /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tab-line`, Component: <TabLine /> },

  { path: `${process.env.PUBLIC_URL}/ui-kits/shadow`, Component: <Shadow /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/list`, Component: <Lists /> },
  { path: `${process.env.PUBLIC_URL}/icons/featherIcons`, Component: <FeatherIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/flagIcons`, Component: <FlagIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/fontAwsomeIcon`, Component: <Fontawesome /> },
  { path: `${process.env.PUBLIC_URL}/icons/icoIcons`, Component: <IcoIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/themifyicons`, Component: <ThemifyIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/weathericons`, Component: <WeatherIcons /> },
  { path: `${process.env.PUBLIC_URL}/buttons/default-btn`, Component: <DefaultButton /> },
  { path: `${process.env.PUBLIC_URL}/buttons/groupBtn`, Component: <GroupButton /> },
  { path: `${process.env.PUBLIC_URL}/learning/learning-list`, Component: <LearningList /> },
  { path: `${process.env.PUBLIC_URL}/faq`, Component: <FAQContent /> },
  { path: `${process.env.PUBLIC_URL}/blog/blogDetail`, Component: <BlogDetail /> },
  { path: `${process.env.PUBLIC_URL}/blog/blogSingle`, Component: <BlogSingle /> },
  { path: `${process.env.PUBLIC_URL}/blog/blogPost`, Component: <BlogPost /> },
  { path: `${process.env.PUBLIC_URL}/jobSearch/job-apply`, Component: <ApplyContain /> },
  { path: `${process.env.PUBLIC_URL}/jobSearch/job-detail`, Component: <JobDetails /> },
  { path: `${process.env.PUBLIC_URL}/jobSearch/job-list`, Component: <ListView /> },
  { path: `${process.env.PUBLIC_URL}/jobSearch/cardView`, Component: <JobCardsContain /> },
  { path: `${process.env.PUBLIC_URL}/knowledgebase/knowledgecategory`, Component: <KnowledgeCategoryContain /> },
  { path: `${process.env.PUBLIC_URL}/knowledgebase/knowledgebase`, Component: <KnowledgeBaseContain /> },
  { path: `${process.env.PUBLIC_URL}/knowledgebase/KnowledgeDetailContain`, Component: <KnowledgeDetailContain /> },
  { path: `${process.env.PUBLIC_URL}/editor/ckEditor`, Component: <CkEditorContain /> },
  { path: `${process.env.PUBLIC_URL}/editor/acecodeeditor`, Component: <ACEEditorContain /> },
  { path: `${process.env.PUBLIC_URL}/editor/mdeEditor`, Component: <MdeEDitorContain /> },
  { path: `${process.env.PUBLIC_URL}/gallery/mesonryGallery`, Component: <MesonryGalleryContain /> },
  { path: `${process.env.PUBLIC_URL}/gallery/mesonryDesc`, Component: <MesonryDescContain /> },
  { path: `${process.env.PUBLIC_URL}/gallery/imageHover`, Component: <ImageHoverContain /> },
  { path: `${process.env.PUBLIC_URL}/gallery/imageWithDesc`, Component: <ImageWithDescContain /> },
  { path: `${process.env.PUBLIC_URL}/gallery/imageGallery`, Component: <ImageGalleryContain /> },
  { path: `${process.env.PUBLIC_URL}/samplepage`, Component: <SampleCard /> },
  { path: `${process.env.PUBLIC_URL}/map/pigeonMap`, Component: <MapJsContain /> },
  { path: `${process.env.PUBLIC_URL}/map/googleMap`, Component: <GoolgeMapsContain /> },
  { path: `${process.env.PUBLIC_URL}/learning/learning-detail`, Component: <DetailCourseContain /> },
  { path: `${process.env.PUBLIC_URL}/charts/apexCharts`, Component: <ApexchartsContain /> },
  { path: `${process.env.PUBLIC_URL}/charts/googleChart`, Component: <GoogleChartsContain /> },
  { path: `${process.env.PUBLIC_URL}/charts/googleChart`, Component: <ChartJsContain /> },
  { path: `${process.env.PUBLIC_URL}/calendar/draggable-calendar`, Component: <DraggableContain /> },
  { path: `${process.env.PUBLIC_URL}/charts/chartistComponent`, Component: <ChartistContain /> },
  { path: `${process.env.PUBLIC_URL}/charts/chartJs`, Component: <ChartJsContain /> },
  { path: `${process.env.PUBLIC_URL}/table/datatable`, Component: <DataTablesContain /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/scrollable`, Component: <Scrollable /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/treeview`, Component: <TreeView /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/rating`, Component: <Rating /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/dropzone`, Component: <Dropzone /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/tourComponent`, Component: <Tour /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/sweetAlert`, Component: <SweetAlert /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/ribbons`, Component: <Ribbons /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/pagination`, Component: <Pagination /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/breadcrumb`, Component: <Breadcrumb /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/rangeSlider`, Component: <RangeSlider /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/imageCropper`, Component: <ImageCropper /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/stickyNotes`, Component: <StickyContain /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/dragNDropComp`, Component: <DragAndDropContain /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/image-upload`, Component: <UploadImageContain /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/card/basicCards`, Component: <BasicCardContain /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/card/draggingCards`, Component: <DragCards /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/timelines/timeline1`, Component: <TimeLineContain /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/pricing`, Component: <PricingMembershipContain /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/whishlist`, Component: <WhishList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/cart`, Component: <Cart /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/datepicker`, Component: <DateTimeContain /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/typeahead`, Component: <FormTypeaheadContain /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/touchspin`, Component: <FormTouchspinContain /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/switch`, Component: <Switch /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/switch`, Component: <Switch /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/switch`, Component: <Switch /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/Select`, Component: <Select /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/clipboard`, Component: <Clipboard /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/datepicker`, Component: <DatePicker /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/rangepicker`, Component: <RangePicker /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/checkout`, Component: <CheckOutContain /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/Add-product`, Component: <AddProductName /> },
  { path: `${process.env.PUBLIC_URL}/notification`, Component: <NotificationTable /> },

];
